// extracted by mini-css-extract-plugin
module.exports = {"totalInvestments":"headerStatistic_totalInvestments__1YjoW","noMargin":"headerStatistic_noMargin__3wYl-"};